import styled from "styled-components"

const Text = styled.p`
    display: block;
    margin-top: 5px;
    font-size: var(--basic-size);
    color: var(--red-color);
    line-height: 1;
`


const RequiredText = ({children}) => (
    <Text>
        {children}
    </Text>
)

export default RequiredText